import { NavigationItemBaseT, NavItemsFooNamesT } from '@/lib/types/navigationTypes.ts'
import NavigationGroupItemContent from '@/components/common/menu/NavigationGroupItemContent.tsx'

export type NavigationButtonT = NavigationItemBaseT & {
  function: NavItemsFooNamesT
}

type PropsT = {
  item: NavigationButtonT
  functionDecider: (functionName: NavItemsFooNamesT) => void | (() => void)
}

export default function NavigationGroupItemButton({ item, functionDecider }: PropsT) {
  return (
    <li className="flex w-full">
      <button onClick={() => functionDecider(item.function)} className="w-full">
        <NavigationGroupItemContent item={item} />
      </button>
    </li>
  )
}
